(function (scope) {
  function resolvePrice(record, values) {
    if (!record || values.length !== record.options.length || values.some((v, i) => !record.options[i].values.includes(v))) return null;
    const matches = record.variants.filter(v => v.options.every((o, i) => !o || o === values[i]));
    if (!matches.length || matches.some(v => v.price !== matches[0].price || v.regular !== matches[0].regular)) return null;
    return matches[0];
  }
  function bakeryDate(now, cutoff = 11) {
    const india = new Date(now.getTime() + 19800000);
    const date = new Date(Date.UTC(india.getUTCFullYear(), india.getUTCMonth(), india.getUTCDate() + (india.getUTCHours() < cutoff ? 1 : 2)));
    if (date.getUTCDay() === 1) date.setUTCDate(date.getUTCDate() + 1);
    return date;
  }
  const api = { resolvePrice, bakeryDate };
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof document === 'undefined') return;
  const money = value => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(value / 100);
  document.querySelectorAll('[data-nb-bakery-ribbon]').forEach(ribbon => {
    function update() {
      const date = bakeryDate(new Date(), Number(ribbon.dataset.cutoff));
      const label = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
      ribbon.querySelector('[data-nb-delivery-message]').textContent = ribbon.dataset.prefix + ' ' + label + ' (' + ribbon.dataset.window + ')';
    }
    update(); setInterval(update, 60000);
  });
  document.querySelectorAll('[data-nb-meal-pricing]').forEach(async widget => {
    const status = widget.querySelector('[data-nb-meal-status]');
    const output = widget.querySelector('[data-nb-meal-price]');
    const compare = widget.querySelector('[data-nb-meal-regular]');
    const controls = widget.querySelector('[data-nb-meal-controls]');
    try {
      const response = await fetch(widget.dataset.sourceUrl, { credentials: 'omit' });
      if (!response.ok) throw new Error('Price data unavailable');
      const catalog = await response.json();
      const record = catalog.products[widget.dataset.sourceId];
      if (!record || record.kind !== 'meals') throw new Error('Plan data unavailable');
      const selects = record.options.map((option, i) => {
        const label = document.createElement('label'); label.className = 'nb-meal-option';
        const name = document.createElement('span'); name.textContent = option.name;
        const select = document.createElement('select'); select.id = widget.id + '-option-' + i;
        option.values.forEach(value => { const el = document.createElement('option'); el.value = value; el.textContent = value; select.append(el); });
        label.append(name, select); controls.append(label); return select;
      });
      function update() {
        const values = selects.map(select => select.value);
        const match = resolvePrice(record, values);
        output.textContent = match ? money(match.price) : widget.dataset.unavailable;
        compare.hidden = !match || match.regular <= match.price;
        compare.textContent = match ? money(match.regular) : '';
        status.textContent = match ? values.join(' · ') : widget.dataset.unavailable;
        widget.dataset.sourceVariation = match?.source_id || '';
      }
      selects.forEach(select => select.addEventListener('change', update)); update();
    } catch {
      output.textContent = widget.dataset.unavailable; compare.hidden = true; status.textContent = widget.dataset.unavailable;
    }
  });
})(typeof window === 'undefined' ? {} : window);
